histories-approval-required-to-sales-manager
  span.event {this.locale().event}
  script(type="typescript").
    this.mixin('histories.base');
